import { JitsiLocalTrack, JitsiRemoteTrack } from 'lib-jitsi-meet'
import { createAction } from 'redux-actions'

export const setVideoMuted = createAction<void>('SET_VIDEO_MUTED')
export const setAudioMuted = createAction<void>('SET_AUDIO_MUTED')
export const addTrackToRoom = createAction<JitsiLocalTrack>('ADD_TRACK_TO_ROOM')
export const detachTrack = createAction<JitsiLocalTrack | JitsiRemoteTrack>('DETACH_TRACK')
export const stopTrack = createAction<JitsiLocalTrack | JitsiRemoteTrack>('STOP_TRACK')

export const attachAudio = createAction<{
  userId: number
  container: HTMLAudioElement | null
  trackToAttach?: JitsiLocalTrack | JitsiRemoteTrack
}>('ATTACH_AUDIO')

export const attachVideo = createAction<number>('ATTACH_VIDEO')
